import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CurrentUsers = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://blog-backend-ivfv.onrender.com/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleDisableUser = async (userId) => {
    try {
      const response = await axios.put(`https://blog-backend-ivfv.onrender.com/users/${userId}/disable`);
      if (response.status === 200) {
        setUsers(users.map(user => user._id === userId ? { ...user, disabled: true } : user));
      }
    } catch (error) {
      console.error('Error disabling user:', error);
    }
  };

  const handleEnableUser = async (userId) => {
    try {
      const response = await axios.put(`https://blog-backend-ivfv.onrender.com/users/${userId}/enable`);
      if (response.status === 200) {
        setUsers(users.map(user => user._id === userId ? { ...user, disabled: false } : user));
      }
    } catch (error) {
      console.error('Error enabling user:', error);
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4 text-primary fw-bold">Current Users</h2>

      {users.length === 0 ? (
        <div className="alert alert-info text-center">No users found.</div>
      ) : (
        <div className="list-group">
          {users.map((user, index) => (
            <div
              key={user._id}
              className="list-group-item border rounded shadow-sm mb-3 d-flex justify-content-between align-items-center"
            >
              <div>
                <span className="badge bg-secondary me-2">#{index + 1}</span>
                <strong className="text-dark">{user.name}</strong>
                <div className="text-muted small">{user.email}</div>
              </div>
              <div className="d-flex align-items-center">
                <span className={`badge me-3 ${user.disabled ? 'bg-danger' : 'bg-success'}`}>
                  {user.disabled ? 'Disabled' : 'Active'}
                </span>

                {user.disabled ? (
                  <OverlayTrigger overlay={<Tooltip>Enable User</Tooltip>}>
                    <button
                      className="btn btn-outline-success btn-sm"
                      onClick={() => handleEnableUser(user._id)}
                    >
                      Enable
                    </button>
                  </OverlayTrigger>
                ) : (
                  <OverlayTrigger overlay={<Tooltip>Disable User</Tooltip>}>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleDisableUser(user._id)}
                    >
                      Disable
                    </button>
                  </OverlayTrigger>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrentUsers;
